import type { QuoteLinePriceDto, QuoteResponse } from "@deliveryapp/shared";

interface CartLineIdentity {
  offerId: string;
  selectedOptions: ReadonlyArray<{ optionId: string }>;
}

function optionKey(ids: readonly string[]): string {
  return [...ids].sort((a, b) => a.localeCompare(b)).join("|");
}

/** Găsește prețul autoritar al exact aceleiași configurații de produs. */
export function quotedPriceForLine(
  line: CartLineIdentity,
  quote: QuoteResponse | null | undefined,
): QuoteLinePriceDto | null {
  const expectedOptions = optionKey(line.selectedOptions.map((option) => option.optionId));
  return (
    quote?.lines?.find(
      (priced) => priced.offerId === line.offerId && optionKey(priced.selectedOptionIds) === expectedOptions,
    ) ?? null
  );
}
